export default __webpack_public_path__ + "static/media/card10.ef8ad5b8.png";